import cx from 'classnames';
import React from 'react';
export var ModalContent = function ModalContent(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return React.createElement("section", {
    className: cx('tds-modal-content', className)
  }, children);
};